import styled from '@emotion/styled';
import {mixinSubHeading} from 'webapp-lib/styling';

export const DocumentTitle = styled.div`
  ${mixinSubHeading}
  margin-bottom: var(--gutter-little);
  height: 32px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
